"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EtudeError_1 = require("../error/EtudeError");
const Exceptional_1 = require("../util/Exceptional");
const MathUtil_1 = require("../util/MathUtil");
class Dynamic {
    constructor(velocity) {
        this.velocity = velocity;
        ++Dynamic.size;
        Dynamic._values.push(this);
        this.velocity = MathUtil_1.default.clamp(Dynamic.MINIMUM_VELOCITY, Dynamic.MAXIMUM_VELOCITY, velocity);
    }
    static values() {
        return Dynamic._values.slice();
    }
    ordinal() {
        return Dynamic._values.indexOf(this);
    }
    static valueOf(dynamicString) {
        const dynamic = Dynamic[dynamicString];
        if (dynamic instanceof Dynamic) {
            return dynamic;
        }
        throw EtudeError_1.default.forInvalid(Dynamic, dynamicString);
    }
    crescendo(amount) {
        return new Dynamic(this.velocity + amount);
    }
    diminuendo(amount) {
        return new Dynamic(this.velocity - amount);
    }
    static fromString(dynamicString) {
        return Exceptional_1.default
            .ofNullable(dynamicString)
            .map(s => s.trim())
            .filter(s => !s.isEmpty())
            .flatMap(s => {
            let dynamic;
            switch (s) {
                case "ppp":
                    dynamic = Dynamic.PIANISSISSIMO;
                    break;
                case "pp":
                    dynamic = Dynamic.PIANISSIMO;
                    break;
                case "p":
                    dynamic = Dynamic.PIANO;
                    break;
                case "mp":
                    dynamic = Dynamic.MEZZO_PIANO;
                    break;
                case "mf":
                    dynamic = Dynamic.MEZZO_FORTE;
                    break;
                case "f":
                    dynamic = Dynamic.FORTE;
                    break;
                case "ff":
                    dynamic = Dynamic.FORTISSIMO;
                    break;
                case "fff":
                    dynamic = Dynamic.FORTISSISSIMO;
                    break;
                default: dynamic = null;
            }
            return Exceptional_1.default.ofNullable(dynamic);
        });
    }
    toString() {
        return this.velocity.toString();
    }
    getVelocity() {
        return this.velocity;
    }
}
Dynamic.MINIMUM_VELOCITY = 0;
Dynamic.MAXIMUM_VELOCITY = 127;
Dynamic.size = 0;
Dynamic._values = [];
Dynamic.PIANISSISSIMO = new Dynamic(16);
Dynamic.PIANISSIMO = new Dynamic(32);
Dynamic.PIANO = new Dynamic(48);
Dynamic.MEZZO_PIANO = new Dynamic(64);
Dynamic.MEZZO_FORTE = new Dynamic(80);
Dynamic.FORTE = new Dynamic(96);
Dynamic.FORTISSIMO = new Dynamic(112);
Dynamic.FORTISSISSIMO = new Dynamic(127);
exports.default = Dynamic;
